import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesCreditBureauComponent} from "./sales-credit-bureau.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {ReactiveFormsModule} from "@angular/forms";
import {GeneralModule} from "../general/general.module";



@NgModule({
  declarations: [
    SalesCreditBureauComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    ReactiveFormsModule,
    GeneralModule,
  ],
  exports: [
    SalesCreditBureauComponent
  ]
})
export class SalesCreditBureauModule { }
